(function(){
  
    var Accordion = function(el, multiple) {
      this.el = el || {};
      this.multiple = multiple || false;

      // Variables privadas
      var links = this.el.find('.link');
      // Evento
      links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
    }

    Accordion.prototype.dropdown = function(e) {
      var $el = e.data.el;
        $this = $(this),
        $next = $this.next();

      $next.slideToggle();
      $this.parent().toggleClass('open');

      if (!e.data.multiple) {
        $el.find('.submenu').not($next).slideUp().parent().removeClass('open');
      };
    } 

    var accordion = new Accordion($('#accordion'), false);
   /**
   * -------------------------
   * TABS FOR PRODUCTS
   * -------------------------
   */
  
   $('ul.tabs').each(function(){
     var active, content, links = $(this).find('a');
     active = links.first().addClass('active');
     content = $(active.attr('href'));
     links.not(':first').each(function () {
     $($(this).attr('href')).hide();
     });
     $(this).find('a').click(function(e){
       active.removeClass('active');
       content.hide();
       active = $(this);
       content = $($(this).attr('href'));
       active.addClass('active');
       content.show();
       return false;
     });
   });
  	
   /**
   * -----------------------------
   * LOAD MORE SPA SERVICES
   * -----------------------------
   */
  
   $('.spa-more').click(function(ev) {
       var anchor = $(this);
       anchor.attr("disabled","disabled");
       anchor.text("Loading...");
       
       setTimeout(function() {
         
         anchor.hide();
         $(".load-more").slideDown();
         
         
       }, 3000);
     
       ev.preventDefault();
   });
  
   /**
   * -----------------------------
   * QUANTITY BUTTONS FOR PRODUCT
   * -----------------------------
   */
  
   $('.pls.altera').click(function() {
       var curr_quantity = $(this).prev().val();
       curr_quantity = parseInt(curr_quantity)+1;
       $(this).prev().val(curr_quantity);
   });
  
   $('.pls.minus').click(function() {
       var curr_quantity = $(this).next().val();
       if(curr_quantity != 0) {
           curr_quantity = parseInt(curr_quantity)-1;
           $(this).next().val(curr_quantity);
       }
   });
   
   var userName = document.querySelector('#quantity');

   userName.addEventListener('input', restrictNumber);
   function restrictNumber (e) {  
    var newValue = this.value.replace(new RegExp(/[^\d]/,'ig'), "");
    this.value = newValue;
   }
   
   
})();
